module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_2_1_2-2718d06275a50baa13b41b128c0f18f5.png";